var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Map } from 'immutable';
import './SizeInput.css';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    });
});
var sizeType = {
    Sneakers: ['4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13'],
    Shirts: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Sweaters: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Pants: ['28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
    Hats: ['30', '31', '32', '33', '34', '35'],
    Costumes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Shorts: ['XS', 'S', 'M', 'L', 'XL', 'XXL']
};
var sizeInput = function (props) {
    var inv = Map();
    var classes = useStyles();
    var sizearr = sizeType[props.Type] || [];
    var _a = useState({}), Inventory = _a[0], SetInventory = _a[1];
    useEffect(function () {
        sizearr.forEach(function (size) {
            inv[size] = '0';
            console.log('working');
        });
    }, [props.Type]);
    var sizeSet = function (e) {
        var name = e.target.name;
        var inventory = Inventory;
        inventory[name] = e.target.value;
        inv[name] = e.target.value;
        var obj = {};
        sizearr.forEach(function (s) {
            var _a;
            obj = __assign({}, obj, (_a = {}, _a[s] = inv[s], _a));
            console.log('size', obj);
        });
        props.updateState(obj);
        // SetInventory({
        //     Inventory: { ...Inventory,
        //         [name]: e.target.value
        //     }
        // })
        console.log(inv);
    };
    return (React.createElement("div", { className: 'sizeinputGrid' }, props.Type ?
        sizearr.map(function (sizes) {
            return React.createElement(TextField, { onChange: sizeSet, name: sizes, key: '', id: 'outlined-basic', label: sizes, variant: 'outlined' });
        })
        : React.createElement("div", null)));
};
export default sizeInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/SizeInput/SizeInput.tsx
// module id = 1302
// module chunks = 0 1 2 3 4 5 6 7